import { bootstrapApplication } from '@angular/platform-browser';
import { extendConfiguration } from '../../common/src/lib/config';
import { environment } from './environments/environment';
import { Settings } from 'luxon';
import { registerLocaleData } from '@angular/common';
import localeDECH from '@angular/common/locales/de-CH';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (typeof (window as any).global === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).global = window;
}

registerLocaleData(localeDECH);

extendConfiguration(environment).then(async () => {
  Settings.defaultLocale = 'de-CH';

  const { appConfig } = await import('./app/app.config');
  const { App } = await import('./app/app');

  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
});
